import React, { useState, useEffect } from "react"
import { navigate } from "gatsby"

export interface IDataTest {
  question: string
  image: string
  answers: [boolean, boolean]
}

interface AppContextInterface {
  questions: IDataTest[]
  clickAnswer: (item: boolean) => any
  activeQuestion: number
  results: any
}

const TestContext = React.createContext<AppContextInterface>({
  clickAnswer: item => {},
  activeQuestion: 1,
  questions: [
    {
      question: "Владимир Павлов ",
      image: "/images/bc-test.svg",
      answers: [true, false],
    },
  ],
  results: [],
})

export interface IData {
  children: React.ReactNode
}

const TestContextProvider = ({ children }: IData) => {
  const [questions, setQuestions] = useState([])
  const [results, setResults] = useState([])

  useEffect(() => {
    fetch("/dataTest.json")
      .then(res => res.json())
      .then(data => {
        setQuestions(data.questions)
      })
  }, [])

  /** Активный вопрос */
  let [activeQuestion, setActiveQuestion] = useState(0)

  /**
   * Функция для работы с тестом
   * @param id number - принимает id выбранного ответа в тесте
   */
  const clickAnswer = (item: boolean) => {
    if (questions.length === activeQuestion + 1) {
      //@ts-ignore
      setResults([...results, item])

      navigate("/result")
    } else {
      //@ts-ignore
      setResults([...results, item])

      /** Меняем стейт активного вопроса */
      setTimeout(() => {
        setActiveQuestion(activeQuestion + 1)
      }, 1000)
    }

    const test__block = document.querySelector(".test__block")
    const test__triangle = document.querySelector(".test__triangle-text")
    const test__question = document.querySelector(".test__question ")

    setTimeout(() => {
      // @ts-ignore
      test__block.style.opacity = "0"
      //@ts-ignore
      test__block.style.transition = "opacity 0.5s, visibility 0s 0.5s"
      //@ts-ignore
      test__triangle.style.opacity = "0"
      //@ts-ignore
      test__question.style.opacity = "0"
    }, 100)

    setTimeout(() => {
      //@ts-ignore
      test__block.style.opacity = "1"
      //@ts-ignore
      test__block.style.transition = "opacity 1s, visibility 0s"
      //@ts-ignore
      test__triangle.style.opacity = "1"
      //@ts-ignore
      test__question.style.opacity = "1"
    }, 1000)
  }

  if (typeof window !== "undefined") {
    const res = results.filter(i => i)
    localStorage.setItem("result", JSON.stringify(res))
  }

  return (
    <TestContext.Provider
      value={{ results, clickAnswer, activeQuestion, questions }}
    >
      {children}
    </TestContext.Provider>
  )
}

export { TestContextProvider, TestContext }
